import { ITournament, TranslationInput } from '@/types'
import { ISportContext } from '@/types/team'

// `IEvent` declares a name and string ids, which holds for calendar and team
// detail. The event-detail endpoint populates `tournament` with the entity and
// generic playlists populate `__belong.Tournament` instead (PRO-1145).
type TournamentNameSource = {
  tournament?: TranslationInput | ISportContext
  __belong?: { Tournament?: Array<string | ISportContext> }
}

const isSportContext = (value: TranslationInput | ISportContext): value is ISportContext =>
  typeof value === 'object' && value !== null && '_id' in value

export const getTournamentName = (
  event: TournamentNameSource | null | undefined,
  tournaments: ITournament[] = []
): TranslationInput | undefined => {
  const tournament = event?.tournament
  if (tournament) return isSportContext(tournament) ? tournament.name : tournament

  const tournamentRefs = event?.__belong?.Tournament
  if (!tournamentRefs) return undefined

  return tournamentRefs
    .map(ref => typeof ref === 'string'
      ? tournaments.find(t => t._id === ref)?.name
      : ref?.name)
    .find(name => !!name)
}
